/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewdownloading2Inputs */

const en_letterpreviewdownloading2 = /** @type {(inputs: Letterpreviewdownloading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing PDF…`)
};

const pt_letterpreviewdownloading2 = /** @type {(inputs: Letterpreviewdownloading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A preparar o PDF…`)
};

/**
* | output |
* | --- |
* | "Preparing PDF…" |
*
* @param {Letterpreviewdownloading2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewdownloading2 = /** @type {((inputs?: Letterpreviewdownloading2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewdownloading2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewdownloading2(inputs)
	return pt_letterpreviewdownloading2(inputs)
});
export { letterpreviewdownloading2 as "letterPreviewDownloading" }